import { operators } from './operators';

const { EQUALS, NOT_EQUALS } = operators;

const numberRangeDataTypes = ['integer', 'decimal', 'currency', 'percent'];

export const hasRangeEndpointValue = (value) =>
    value !== null && value !== undefined && value !== '';

export const countRangeEndpointValues = (value = []) => value.filter(hasRangeEndpointValue).length;

const getComparableRangeEndpoint = (value) => {
    if (!hasRangeEndpointValue(value)) return null;

    const numberValue = typeof value === 'number' ? value : Number(String(value).replace(',', '.'));

    return Number.isFinite(numberValue) ? numberValue : null;
};

export const normalizeNumberRangeEqualityValue = ({ dataType, operator, value }) => {
    if (
        !numberRangeDataTypes.includes(dataType) ||
        ![EQUALS, NOT_EQUALS].includes(operator) ||
        !Array.isArray(value)
    ) {
        return value;
    }

    const [from, to] = value;
    const hasFrom = hasRangeEndpointValue(from);
    const hasTo = hasRangeEndpointValue(to);

    if (hasFrom === hasTo) return value;

    const filledValue = hasFrom ? from : to;
    return [filledValue, filledValue];
};

export const normalizeNumberRangeOrderValue = ({ dataType, value, changedIndex }) => {
    if (!numberRangeDataTypes.includes(dataType) || !Array.isArray(value)) {
        return value;
    }

    const [from, to] = value;
    const fromNumber = getComparableRangeEndpoint(from);
    const toNumber = getComparableRangeEndpoint(to);

    if (fromNumber === null || toNumber === null || fromNumber <= toNumber) {
        return value;
    }

    if (changedIndex === 0) return [to, to];
    if (changedIndex === 1) return [from, from];

    return [to, from];
};
